import { render, staticRenderFns } from "./LoginSocialTwoFactorPage.vue?vue&type=template&id=6f2b869d&"
import script from "./LoginSocialTwoFactorPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LoginSocialTwoFactorPage.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports